import React, { createContext, useContext, useState } from "react";


import './loader.css';

const LoadingContext = createContext({
    loading: false,
    setLoading: null,
});

export function Loader({ children }) {
    const [loading, setLoading] = useState(false);
    const value = { loading, setLoading };
    return (
        <LoadingContext.Provider value={value}>
            {
                loading ? <div className="xcd-loader" role="status" aria-live="polite">
                    <div className="xcd-loader-icon">
                        <div className="nx-spinner" />
                        <p className="nx-loader-label">Loading</p>
                    </div>
                </div> : <> </>
            }

            {children}
        </LoadingContext.Provider>
    );
}

export function useLoader() {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error("useLoader must be used within Loaderr");
    }
    return context;
}